import { render, staticRenderFns } from "./WinnerPreviewModal.vue?vue&type=template&id=2b7cc801&scoped=true"
import script from "./WinnerPreviewModal.vue?vue&type=script&lang=js"
export * from "./WinnerPreviewModal.vue?vue&type=script&lang=js"
import style0 from "./WinnerPreviewModal.vue?vue&type=style&index=0&id=2b7cc801&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7cc801",
  null
  
)

export default component.exports